import { HttpClient } from '@angular/common/http';
import { Injectable, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { MagezineDetail } from '../../shared/interfaces/index.interface';
import { JwtService } from '../index.service';

@Injectable({
  providedIn: 'root'
})
export class MagezineService implements OnInit{
  readonly BASE_URL = environment.BASE_API_URL;
  constructor(
    private http:HttpClient,
    public jwtService:JwtService
  ) {}
  ngOnInit() {}
  getAllMagezine(page:number = 1){
    return this.http.get<MagezineDetail>(this.BASE_URL+`magazine/?page=${page}`)
  }
  createMagezine(data:any){
    return this.http.post<MagezineDetail>(this.BASE_URL+`magazine/`, data );
  }
  getAllMagezineCategoryField(){
    return this.http.get<any>(this.BASE_URL+`magazine/magazine_category/list/`)
  }
  getSearchedCategoryField(title:string){
    if(title==''){
      return this.getAllMagezineCategoryField()
    }else{
      return this.http.get<any>(this.BASE_URL+`magazine/magazine_category/list/?search=${title}`)
    }
  }
  getSingleMagezine(name:string | undefined){
    return this.http.get<MagezineDetail>(`${this.BASE_URL}magazine/${name}/`)
  }
}